import { render, staticRenderFns } from "./UQube.vue?vue&type=template&id=58a98639"
import script from "./UQube.vue?vue&type=script&lang=js"
export * from "./UQube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports